import { useDataTableSelector } from "./DataTableStateProvider";
import { GridState, GridRecord } from "./DataTable.types";

const DATA_SELECTOR = <S>(s: GridState<S>) => s.data;
export const useDataTableData = <S>(): Array<GridRecord<S>> => {
  return useDataTableSelector<S, Array<GridRecord<S>>>(DATA_SELECTOR);
};
